import {
  MenuItem,
  Select,
  type SelectChangeEvent,
  Tab,
  Tabs as MuiTabs,
  Typography,
  styled,
  Box
} from '@mui/material'
import { ExpandLess, ExpandMore } from '@mui/icons-material'
import { color } from 'config/color'
import { useState } from 'react'
import { useMobileBreakpoints } from 'utils/hooks/useMobileBreakpoints'

export interface ITabOption {
  title: string
  content: JSX.Element
}

export interface ITabs {
  isVisible: boolean
  tabOptions: ITabOption[]
  activeTab: number
  handleTabChange: (_e: any, newActiveTab: number) => void
  handleSelectChange: (event: SelectChangeEvent) => void
}

export const Tabs = (props: ITabs): JSX.Element => {
  const [isOpen, setIsOpen] = useState(false)

  const isMobile = useMobileBreakpoints()

  return (
    <Box mt={3}>
      {isMobile && props.isVisible
      ? (
        <Select
          variant="standard"
          fullWidth
          value={String(props.activeTab)}
          onOpen={() => {
            setIsOpen(true)
          }}
          onClose={() => {
            setIsOpen(false)
          }}
          onChange={props.handleSelectChange}
          sx={{
            bgcolor: color.white,
            borderBottom: `solid 1px ${color.secondary.dark[200]}`,
            p: 2
          }}
          disableUnderline={true}
          IconComponent={() =>
            isOpen
            ? (
              <ExpandLess sx={{ color: color.primary[700] }} />
            )
            : (
              <ExpandMore sx={{ color: color.primary[700] }} />
            )
          }
        >
          {props.tabOptions.map((tab, index) => {
            return (
              <MenuItem key={index} value={index}>
                <Typography
                  fontSize={24}
                  fontWeight={500}
                  color={color.primary[700]}
                  alignItems="center"
                >
                  {tab.title}
                </Typography>
              </MenuItem>
            )
          })}
        </Select>
      )
      : (
        <>
          {props.isVisible && (
            <StyledMuiTabs
              variant="fullWidth"
              value={props.activeTab}
              onChange={props.handleTabChange}
              TabIndicatorProps={{
                sx: { background: color.primary[500], height: '4px' }
              }}
            >
              {props.tabOptions.map((tab, index) => {
                return (
                  <Tab
                    key={index}
                    label={tab.title}
                    sx={{
                      textTransform: 'none',
                      fontSize: 18,
                      fontWeight: 400,
                      height: 65
                    }}
                  />
                )
              })}
            </StyledMuiTabs>
          )}
        </>
      )}
      {props.tabOptions[props.activeTab].content}
    </Box>
  )
}

const StyledMuiTabs = styled(MuiTabs)({
  '& .MuiTab-root': {
    background: color.white,
    borderBottom: `solid 1px ${color.secondary.dark[200]}`,
    color: color.primary[700],
    padding: '16px'
  },
  '& .MuiTab-root.Mui-selected': {
    backgroundColor: color.primary[900],
    color: color.white
  }
})
